import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workers-item',
  templateUrl: './workers-item.component.html',
  styleUrls: ['./workers-item.component.css']
})
export class WorkersItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
